import { useState } from 'react';

const AddProcessPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddProcessPopup, setShowAddProcessPopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddProcessPopup(!showAddProcessPopup);
    };

    return (
      <Component
        showAddProcessPopup={showAddProcessPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddProcessPopupHOC;
